/** Decimal UI text, not a permissive JavaScript numeric literal or a prefix.
 * Keep the original string in UI state: a trailing separator is valid while typing.
 * Empty/invalid text is NaN (never silently zero); callers own range/nullable rules.
 */
export function parseNumericInput(text, integer = false) {
    const trimmed = text.trim();
    if (!/^[+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(trimmed))
        return NaN;
    const value = Number(trimmed.replace(',', '.'));
    return Number.isFinite(value) && (!integer || Number.isSafeInteger(value)) ? value : NaN;
}
//# sourceMappingURL=numeric-input.js.map